import React from "react"
import { QRCodeSVG } from "qrcode.react"
import { Box } from "@mui/material"

interface QRCodeWithIconProps {
  value: string
  size?: number
  iconSize?: number
  iconColor?: string
  icon: React.ReactNode
  width?: string
  height?: string
  style?: React.CSSProperties
}

const QRCodeWithIcon: React.FC<QRCodeWithIconProps> = ({ value, size, icon, ...rest }) => {
  return (
    <Box sx={{ position: "relative", display: "inline-block" }}>
      <QRCodeSVG
        value={value}
        size={size}
        level="Q" // Medium error correction level to allow for logo overlay
        // includeMargin={true}
        {...rest}
      />
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          backgroundColor: "white",
          borderRadius: "50%",
          padding: "2px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
          // border: "1px solid #000"
          //   boxShadow: "0 1px 3px rgba(0,0,0,0.2)"
        }}
      >
        {icon}
      </Box>
    </Box>
  )
}

export default QRCodeWithIcon
